import { inject, Injectable, signal } from "@angular/core";
import { SessionStorageService } from "./session-storage.service";

@Injectable({
    providedIn:'root'
})
export class TokenService{

   private access_token_=signal<string>('');
   private storage=inject(SessionStorageService);


    decodeJwtPayload(token: string): any {
        const parts = token.split('.');
        
        if (parts.length !== 3) {
          throw new Error('Invalid JWT format.');
        }
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
        );
    
        return JSON.parse(jsonPayload);
      }

    setAccessToken(token:string,refresh_token:string,token_type:string,expires_in:number){
      this.access_token_.set(token);
      this.storage.set('access_token',token);
      this.storage.set('refresh_token',refresh_token);
      this.storage.set('token_type',token_type);
      this.storage.set('expires_in',expires_in.toString());
    }

    getAccessToken():string{
      return this.storage.get('access_token') ?? this.access_token_();
    }
}